import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  userId: null,
  user: null,
  admin: null,
  staff: null,
  credential:null
};

const authSuccess = (state, action) => {
  return updateObject(state, action.payload);
};

const authLogout = (state) => {
  return updateObject(state, { userId: null });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_CONTROLS:
      return updateObject(state, action.payload);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state);
    case actionTypes.SET_USER:
      return updateObject(state,action.payload)
    default:
      return state; 
  }
};

export default reducer;
